import { Component, OnInit, Input } from '@angular/core';
import { faConstruction} from '@fortawesome/pro-light-svg-icons';
import { LettersService } from 'src/app/shared/services/letters.service';
import { CorrespondenceTimelineService } from 'src/app/shared/services/correspondence-timeline.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-adhoc-letter',
  templateUrl: './adhoc-letter.component.html',
  styleUrls: ['./adhoc-letter.component.scss']
})
export class AdhocLetterComponent implements OnInit {

  @Input() caseId: number;
  recipients: any[] = [];
  recipientType: any = null;
  generatingLetter: boolean = false;
  generatingError: boolean = false;
  errorMessage: string = "";

  faConstruction = faConstruction;

  constructor(public activeModal: NgbActiveModal,
              private lettersService: LettersService,
              private correspondenceTimelineService: CorrespondenceTimelineService
              ) {

   
  }

  ngOnInit() {
     this.lettersService.getLetterRecipientsForCase(this.caseId).subscribe((response : any) => {

      this.recipients = response.letterRecipients;
    });
  }

  generateLetter(){
    this.generatingLetter = true;
    this.lettersService.generateAdHocLetterForRecipient(this.caseId, this.recipientType).subscribe((response : any) => {
      this.generatingLetter = false;
      this.activeModal.close(true);
      this.correspondenceTimelineService.refreshCaseTimeline.next();
    }, (error : any) => {

      this.generatingError = true;
      if(error.status == 999)
        this.errorMessage = error.error;
      else if(error.status == 500 )
        this.errorMessage = "Internal Error";
      else
        this.errorMessage = error.statusText;

    });
  }
}
